import { render, staticRenderFns } from "./AccountResetValidation.vue?vue&type=template&id=ffee904c&scoped=true"
import script from "./AccountResetValidation.vue?vue&type=script&lang=js"
export * from "./AccountResetValidation.vue?vue&type=script&lang=js"
import style0 from "./AccountResetValidation.vue?vue&type=style&index=0&id=ffee904c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffee904c",
  null
  
)

export default component.exports